import { VehicleSelectionHierarchyLabel } from '../enums';
import { COMMERCIAL_VEHICLE_TYPE_IDS } from "../../common";
export class VehicleSelectionConstants {
}
VehicleSelectionConstants.vinLength = 17;
VehicleSelectionConstants.serviceVersion = 'v1';
VehicleSelectionConstants.numberOfConfigItems = 9;
VehicleSelectionConstants.genericDecodeTypeIds = [50, 999]; /** Generic and Commercial Generic */
VehicleSelectionConstants.commercialGenericVehicleTypeIds = COMMERCIAL_VEHICLE_TYPE_IDS;
export const vehicleSelectionHierarchy = Object.keys(VehicleSelectionHierarchyLabel).map(k => VehicleSelectionHierarchyLabel[k]);
export const DefaultVehicleSelectionLabels = {
    DEFAULT_TYPE_LABEL: 'Type',
    DEFAULT_YEAR_LABEL: 'Year',
    DEFAULT_MAKE_LABEL: 'Make',
    DEFAULT_MODEL_LABEL: 'Model',
    DEFAULT_SUBMODEL_LABEL: 'Sub Model',
    DEFAULT_BODYSTYLE_LABEL: 'Body Style',
    DEFAULT_ENGINE_LABEL: 'Engine/Motor',
    DEFAULT_TRANSMISSION_LABEL: 'Transmission/Direct Drive',
    DEFAULT_DRIVETRAIN_LABEL: 'Drivetrain'
};
//# sourceMappingURL=constants.js.map